<template>
  <v-container fill-height 
  :style="{
  minHeight: $vuetify.breakpoint.xsOnly ? 'calc(100vh - 300px)' : 
  $vuetify.breakpoint.smOnly ? 'calc(100vh - 300px)' :
  'calc(100vh - 150px)'
}">
       <v-card  v-if="sendlinksuccess" width="500"  max-width="500" class="mx-auto my-6 pa-4" :elevation="2" style="border-radius:30px;
       box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <v-card-title class="justify-center font-weight-bold text-sm-h5">{{
          this.lg_forgotpassword.reset_title
        }}</v-card-title>
        <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_forgotpassword.reset_subtitle1}}
        </v-col>
        </v-row>

           <v-row>
           <v-col justify="center" align="center" cols="12" class="ml-n4 mt-n6">
           <v-btn
                text
                class="mb-1 blue--text rounded-pill text-decoration-underline"
                width="300"
                height="40"
                 @click="onClickMenu('/login-account')"
              >
              {{ this.lg_forgotpassword.reset_btn }}
              </v-btn>
        </v-col>
        </v-row>
      </v-card>

      <v-card v-else width="500"  max-width="500" class="mx-auto my-6 pa-4" :elevation="2" style="border-radius:30px;
      box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <v-row>
           <v-col justify="center" align="left" cols="12">
           <v-btn
                icon
                class="mb-1 black--text"
                 @click="onClickMenu('/login-account')"
              >
               <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
        </v-col>
        </v-row>
        <v-card-title class="justify-center font-weight-bold text-sm-h5 mt-n8">{{
          this.lg_forgotpassword.title
        }}</v-card-title>
        <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_forgotpassword.subtitle1}}
        </v-col>
        </v-row>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-form @submit.prevent="submit" v-model="valid" ref="form" >
            <!-- Username field -->
              <v-row class="mt-8" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="10" lg="10" md="10" sm="12" xs="12">
            <v-text-field
              dense
              outlined
              :label="this.lg_forgotpassword.label"
              :placeholder="this.lg_forgotpassword.label"
              v-model="account.username"
              required
              :rules="emailRules"
              prepend-inner-icon="mdi-email-outline"
            ></v-text-field>
            </v-col>
                </v-row>

                 <v-row class="mx-sm-4 mt-n6">
           <v-col justify="center" align="left" cols="12">
        <p class="text-caption">{{ this.lg_forgotpassword.subtitleforemail }}</p>
        </v-col>
        </v-row>
        

           <v-row class="mt-4" justify="center" >
              <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <v-btn
                type="submit"
                class="mb-1 white--text slide-btn"
                width="300"
                height="40"
                outlined
              >
              {{ this.lg_forgotpassword.send }}
              </v-btn>
              </v-col>
              </v-row>

              <v-row class="mx-sm-4">
           <v-col justify="center" align="left" cols="12">
        {{ this.lg_forgotpassword.subtitle2 }}
        </v-col>
        </v-row>
               

               <v-row class="mx-sm-4">
           <v-col justify="center" align="left" cols="12">
         {{ this.lg_forgotpassword.subtitle3 }}
        </v-col>
        </v-row>

           <v-row class="mx-sm-4">
           <v-col justify="center" align="left" cols="12" class="ml-n4 mt-n6">
            <v-btn
                text
               @click="onClickMenu('/contact')"
                
              >
              {{ this.lg_forgotpassword.subtitle4 }}
              </v-btn>
        </v-col>
        </v-row>
          </v-form>
        </v-card-text>
      </v-card>



    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script lang="js">

import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { server } from "../services/constants";
import { feature } from "../services/constants";
import { lg_forgotpassword } from "./language/lg_forgotpassword.js";

  export default  {
    name: 'forgot',
    props: [],
    created() {
    },
    components: {
      LoadingDialog,
    },
    mounted () {
      localStorage.setItem(server.MEET_STA, "false");
      if (api.isLoggedIn()){
        this.$router.push("/")
      }
    },
    data () {
          return {
            messageAlert: "Email หรือ Password ไม่ถูกต้อง กรุณาตรวจสอบข้อมูล",
            account:{
              username:""
            },
            valid: false,
            e1: true,
            email: '',
            emailRules: [],
            isRequired: true,
            sendlinksuccess:false,
          }
        },
        watch: {
    isRequired(val) {
      if (val) {
        this.emailRules = [v => !!v || `${this.lg_forgotpassword.put_required}`];
      } else {
        this.emailRules = [];
      }
    }
  },
        methods: {
          async submit () {
              if (this.$refs.form.validate()) {
                this.$swal.showLoading();
                 try {
                
                const username = this.account.username
                const body = {username}
                const res = await api.forgot(body)
                this.$swal.close();
                if(res.data && res.data.link) {
                    // this.$swal.fire("Success", res.data.message, "success");
                    // this.$router.push("/");
                  await this.clear();
                  this.sendlinksuccess = true;
                  return;
                } else {
                   this.$swal.fire("Error", res.data.message, "error");
                    return;
                }
              }
              catch (error) {
                // console.log(error);
                this.$swal.fire("Error", error.message, "error");
                return;
              }
            }
          },
          onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
         async clear () {
            this.$refs.form.reset()
          }
        },
    computed: {
       widthcard() {
      switch (this.$vuetify.breakpoint.name) {
         case "xs":
          return "width:80%";
        case "sm":
            return "width:50%";
        case "md":
           return "width:40%";
        case "lg":
           return "width:30%";
        case "xl":
            return "width:30%";
      }
    },
 buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    },
     beforeCreate() {
       window.scrollTo( screen.width/2, screen.height/2 );
      this.$store.state.page_reload = false;
      this.$store.state.altLogin = false;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_forgotpassword = lg_forgotpassword.lg_forgotpassword_th
        : this.lg_forgotpassword = lg_forgotpassword.lg_forgotpassword_en;

        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
        async mounted(){
      this.emailRules = this.isRequired ?[(v) => !!v || `${this.lg_forgotpassword.put_required}`,]: [];
    }
}
</script>

<style scoped >

.textinform{
  width:75%;
}
@media (max-width: 599px) {
  .joinmeeting-container {
    margin-top:-150px;
  }
  .v-main {
    margin-top:-50px;
    height: 110% !important;
  }
}
@media (max-width: 959px) {
  .joinmeeting-container {
    margin-top:-180px !important;
  }
}

@media (min-width: 1260px) {
  .joinmeeting-container {
    margin-top: 5rem;
  }
  
}

/* .v-main {
    max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important;
} */
.joinmeeting-container {
    margin-top: -10px;
  }
</style>
